// Validates a user-selected file is a PDF within a size limit. Returns a
// human-readable error message, or null when the file is acceptable.
// Centralised so the module and reference PDF upload controls apply the
// same mime check and a consistent "less than NMB" message instead of
// each hand-rolling a divergent limit.

export function validatePdfFile(
  file: File,
  maxBytes: number,
): string | null {
  if (file.type !== "application/pdf") {
    return "Please select a PDF file";
  }
  if (file.size > maxBytes) {
    const mb = Math.round(maxBytes / (1024 * 1024));
    return `File size must be less than ${mb}MB`;
  }
  return null;
}
